/* eslint-disable no-unused-vars,arrow-body-style,no-param-reassign */
/* global G */
import { curry, getFirstItem } from 'lib/util'
import {
  back,
  edit,
  list,
  persistChange,
  persistCheck,
  persistOption,
  persistOptions,
  redirect,
  submit,
} from '@app/_shared/events'
import { jump as jumpBack, list as listBreadcrumbs } from 'app/_shared/events/breadcrumbs'
import detail from 'app/_shared/events/action/detail'
import search from 'app/_shared/events/search'
import infinite from 'app/_shared/events/search/infinite'
import createRedirect from 'app/_shared/events/appbar/createRedirect'
import listCountries from 'app/_shared/events/collection/listCountries'
import listUserCountries from 'app/_shared/events/collection/listUserCountries'
import listStatus from 'app/_shared/events/collection/listStatus'
import { conflict, count, document, item, own, reference } from 'app/_shared/events/pubsub'
import menu from 'app/_shared/events/contextmenu'
import link from 'app/_shared/events/link'
import listTicketTypes from 'app/_shared/events/collection/listTicketTypes'
import listTicketStatus from 'app/_shared/events/collection/listTicketStatus'
import listStatusReasons from 'app/_shared/events/collection/listStatusReasons'
import listOrganisationTypes from 'app/_shared/events/collection/listOrganisationTypes'
import countOpenRequests from 'app/_shared/events/widget/count/openRequests'
import countPersons from 'app/_shared/events/widget/count/contacts'
import countServiceItems from 'app/_shared/events/widget/count/activeDevices'
import { acl, cell, model, permission } from 'app/_shared/events/acl'
import toDetailsOrIndex from 'app/_shared/events/redirect/toDetailsOrIndex'
import chain from 'app/_shared/events/util/chain'
import prefillSupportedBy from 'app/_shared/events/prefillSupportedBy'
import { refList } from 'app/_shared/events/list'
import searchExclude from 'app/_shared/events/searchExclude'
import sublist from 'app/_shared/events/util/sublist'
import searchUnsortedAndRecreate from 'app/_shared/events/appbar/searchUnsortedAndRecreate'
import searchWith from 'app/_shared/events/search/with'
import setCountedLabel from 'app/_shared/events/tabs/setCountedLabel'
import persistStore, { persistOptionsStore } from 'app/_shared/events/combined/persistStore'
import destroy from 'app/_shared/events/destroy'
import showDialogAndPersistOptions from 'app/_shared/events/combined/showDialogAndPersistOptions'
import persistCheckAndAction from 'app/_shared/events/combined/persistCheckAndAction'
import hasMultipleFilters from 'app/_shared/events/search/query/hasMultipleFilters'
import listInvitationStatuses from 'app/_shared/events/collection/listInvitationStatuses'
import listInvitationRoles from 'app/_shared/events/collection/listInvitationRoles'
import listUserRoles from 'app/_shared/events/collection/listUserRoles'
import persistTab from 'app/_shared/events/tabs/persist'
import persistOptionsAndAction from 'app/_shared/events/combined/persistOptionsAndAction'
import remember from 'app/_shared/events/remember'
import action from 'app/_shared/events/action'
import excludeNotConfirmedForRoles from 'app/_shared/events/search/query/excludeNotConfirmedForRoles'
import listRequestStatus from 'app/_shared/events/collection/listRequestStatus'
import setListDrawerTitle from 'app/_shared/events/tabs/setListDrawerTitle'
import fromUserOrgs from 'app/_shared/events/search/query/fromUserOrgs'
import listSupportedBy from 'app/_shared/events/listSupportedBy'
import destroyIfNoSubItems from 'app/organisation/event/destroyIfNoSubItems'
import supportedBy from 'app/organisation/event/dialog/supportedBy'
import parent from 'app/organisation/event/dialog/parent'
import submitIfConfirmed from 'app/organisation/event/submitIfConfirmed'
import checkMergeAndPersistStore from 'app/organisation/event/checkMergeAndPersistStore'
import redirectWithOrganisation from 'app/organisation/event/redirectWithOrganisation'
// TODO: Move to _shared
import redirectToCheckOrApproveWith from 'app/organisation/event/redirectToCheckOrApproveWith'
import showDialogOrRedirectWith from 'app/organisation/event/showDialogOrRedirectWith'
import getValidationStatus from 'app/person/event/getValidationStatus'
import displayState from 'app/_shared/events/address/displayState'
import displayHouseNumber from 'app/_shared/events/address/displayHouseNumber'
import update from 'app/_shared/events/util/update'
import listStates from 'app/_shared/events/collection/listStates'
import { countWithFilter, countWithFilterAndQuery } from 'app/_shared/events/pubsub/countWith'
import { platform } from 'app/_shared/events/util'
import { toggleFavoriteFromModel } from 'app/_shared/events/favorite/toggle'
import { submitModalWith } from 'app/_shared/events/modal/submit'
import { closeModalWith } from 'app/_shared/events/modal/close'
import focusNext from 'app/_shared/events/field/focusNext'
import createWithOrganisation from './event/createWithOrganisation'
import ticketHasOrganisationOrPartyOrItem from 'app/_shared/events/search/query/ticketHasOrganisationOrPartyOrItem'
import requestHasOrganisationOrPartyOrItem from 'app/_shared/events/search/query/requestHasOrganisationOrPartyOrItem'

export default {
  acl: {
    acl,
    cell,
    model,
    permission,
  },
  onOpen: {
    listing: list('default'),
    listWithRefs: list(null),
    listVerbose: list('verbose'),
    refListVerbose: refList('verbose'),
    refListWithCount: curry(async (module, component, event) => (
      module[G.ADAPTER][G.SESSION][G.STATE][G.CONTEXT] === 'req'
        ? await refList('defaultWithRequestCount', module, component, event)
        : await refList('defaultWithTicketCount', module, component, event)
    )),
    infinite: infinite(null),
    infiniteVerbose: infinite('verbose'),
    infiniteWithQuery: chain(
      searchWith(['query']),
      infinite(null),
    ),
    infiniteWithFilter: chain(
      searchWith(['filter']),
      infinite(null),
    ),
    infiniteWithRequestCountAndFilterAndQuery: chain(
      searchWith(['filter', 'query']),
      infinite('defaultWithRequestCount'),
    ),
    infiniteShortWithFilter: chain(
      searchWith(['filter']),
      infinite('short'),
    ),
    infiniteVerboseWithFilter: chain(
      searchWith(['filter']),
      infinite('verbose'),
    ),
    infiniteWithCountWithFilter: curry(async (module, component, event) => {
      await searchWith(['filter'], module, component, event)
      return module[G.ADAPTER][G.SESSION][G.STATE][G.CONTEXT] === 'req'
        ? await infinite('defaultWithRequestCount', module, component, event)
        : await infinite('defaultWithTicketCount', module, component, event)
    }),
    infiniteWithCountWithFilterAndQuery: curry(async (module, component, event) => {
      await searchWith(['filter', 'query'], module, component, event)
      return module[G.ADAPTER][G.SESSION][G.STATE][G.CONTEXT] === 'req'
        ? await infinite('defaultWithRequestCount', module, component, event)
        : await infinite('defaultWithTicketCount', module, component, event)
    }),
    listCountries,
    listStates,
    search: search(null),
    searchVerbose: search('verbose'),
    searchWithFilter: chain(
      searchWith(['filter']),
      search(null),
    ),
    searchWithCountWithFilterAndQuery: curry(async (module, component, event) => {
      await searchWith(['filter', 'query'], module, component, event)
      return module[G.ADAPTER][G.SESSION][G.STATE][G.CONTEXT] === 'req'
        ? await search('defaultWithRequestCount', module, component, event)
        : await search('defaultWithTicketCount', module, component, event)
    }),
    searchOther: searchExclude('short'),
    getValues: curry(async (module, component, event, values) => values || []),
    reference, // edit form
    own,
    link,
    setTabSearch: searchWith(['filter']),
    setTabSearchWithQuery: searchWith(['filter', 'query']),
    setTabSearchAndListDrawerTitle: chain(
      searchWith(['filter']),
      setListDrawerTitle,
    ),
    setTabSearchWithQueryAndListDrawerTitle: chain(
      searchWith(['filter', 'query']),
      setListDrawerTitle,
    ),
    getValidationStatus,
    listStatus,
    listOrganisationTypes,
    listBreadcrumbs,
  },
  onShowAll: {
    infinite: infinite('verbose'),
    infiniteWithFilter: chain(
      searchWith(['filter']),
      infinite(null),
    ),
    infiniteVerboseWithFilter: chain(
      searchWith(['filter']),
      infinite('verbose'),
    ),
    infiniteWithCountWithFilter: curry(async (module, component, event) => {
      await searchWith(['filter'], module, component, event)
      return module[G.ADAPTER][G.SESSION][G.STATE][G.CONTEXT] === 'req'
        ? await infinite('defaultWithRequestCount', module, component, event)
        : await infinite('defaultWithTicketCount', module, component, event)
    }),
    infiniteWithCountWithFilterAndQuery: curry(async (module, component, event) => {
      await searchWith(['filter', 'query'], module, component, event)
      return module[G.ADAPTER][G.SESSION][G.STATE][G.CONTEXT] === 'req'
        ? await infinite('defaultWithRequestCount', module, component, event)
        : await infinite('defaultWithTicketCount', module, component, event)
    }),
  },
  onSearch: {
    searchUnsortedAndRecreate,
  },
  onCreate: {
    createRedirect,
    createWithOrganisation,
  },
  onClose: {
    redirect,
    back,
    resetFavorite: closeModalWith('favoriteModal'),
  },
  onClick: {
    toggleFavorite: toggleFavoriteFromModel,
    favorite: submitModalWith('submitFavorite'),
    edit,
    redirect,
    submit,
    submitIfConfirmed,
    detail,
    back,
    toDetailsOrIndex,
    redirectWith: redirectWithOrganisation,
    redirectToRequestWith: redirectWithOrganisation,
    redirectToTicketWith: redirectWithOrganisation,
    redirectToCheckOrApproveWith,
    showDialogOrRedirectWith,
    destroy,
    destroyIfNoSubItems,
    jumpBack,
  },
  onChange: {
    persistChange,
    persistCheckAndAction,
    persistOptions,
    persistStore,
    checkMergeAndPersistStore,
    persistOptionsStore,
    persistCountry: curry(async (module, component, componentInfo, attributeInfo, event) => await chain(
      persistOptions,
      prefillSupportedBy,
      displayState('state', 'country', componentInfo, attributeInfo),
      displayHouseNumber('number', 'street', componentInfo, attributeInfo),
      update,
    )(module, component, event)),
    persistStates: persistOptions,
    fillSupportedByAndPersistChange: chain(
      persistChange,
      prefillSupportedBy,
    ),
    persistOption,
    persistOptionsAndAction,
    showDialogAndPersistOptions,
    persistTabAndRemember: chain(
      persistTab,
      remember,
      platform({
        mobile: update,
      }),
    ),
    persistOptionsRememberAndAction: chain(
      persistOptions,
      remember,
      action,
    ),
    persistCheckRememberAndAction: chain(
      persistCheck,
      remember,
      action,
    ),
  },
  onSubscription: {
    organisation: reference,
  },
  // form listener on pub
  onPublication: {
    document,
    conflict,
    countOpenRequests,
    countPersons,
    countServiceItems,
    countWithFilter,
    countWithFilterAndQuery,
  },
  onSubmit: {
    focusNext: focusNext(null),
  },
  // cell count
  count: {
    sub: count,
  },
  // list item row
  item: {
    sub: item,
  },
  list: {
    sub: own,
  },
  onContextMenu: {
    menu: menu(null),
  },
  onPage: {
    remember,
  },
  onLinkChange: {
    setLink: link,
  },
  getTicketType: {
    listTicketTypes,
  },
  getStatus: {
    listTicketStatus,
    listRequestStatus,
    listInvitationStatuses,
    listStatus,
  },
  getInvitationStatus: {
    listInvitationStatuses,
  },
  getInvitationRole: {
    listInvitationRoles,
  },
  getUserRole: {
    listUserRoles,
  },
  getStatusReason: {
    listStatusReasons,
  },
  getOrganisationType: {
    listOrganisationTypes,
  },
  getSelection: {
    listSupportedBy,
    listOrganisationTypes: curry(async (module, component, event) => {
      return sublist(
        ['customer', 'independent_contractor', 'internal', 'partner'],
        listOrganisationTypes,
      )(module, component, event).map((type) => {
        delete type.icon
        return type
      })
    }),
    listUserCountries,
  },
  getLabel: {
    setCsmLabel: setCountedLabel({ ns: 'ticket', key: 'tickets' }),
    setReqLabel: setCountedLabel({ ns: 'ticket', key: 'requests' }),
    setDeviceLabel: setCountedLabel({ ns: 'device', key: 'devices' }),
    setPersonLabel: setCountedLabel({ ns: 'person', key: 'contacts' }),
    setChildOrganisationLabel: setCountedLabel({ ns: 'organisation', key: 'childOrganisations' }),
    setOrganisationLabel: curry(async (module, component, event) => {
      const providesSupport = module[G.MODEL][G.CACHE]?.value?.support?.provides
      const label = await setCountedLabel(
        { ns: 'organisation', key: 'supportedOrganisations' },
        module,
        component,
        event,
      )

      return providesSupport || label.count > 0
        ? label
        : { ...label, hidden: true }
    }),
    listOrganisationTypes,
  },
  dialog: {
    supportedBy,
    parent,
  },
  filter: {
    requesterOrganisation: curry((module, component, event) => (
      { requesterContactOrg: module[G.MODEL][G.STATE][G.REF] }
    )),
    itemInstalledAt: curry((module, component, event) => (
      { itemInstalledAt: module[G.MODEL][G.STATE][G.REF] }
    )),
    installedAt: curry((module, component, event) => (
      { installedAt: module[G.MODEL][G.STATE][G.REF] }
    )),
    organisation: curry((module, component, event) => (
      { organisation: module[G.MODEL][G.STATE][G.REF] }
    )),
    requesterOrg: curry((module, component, event) => (
      { requesterOrg: module[G.MODEL][G.STATE][G.REF] }
    )),
    requesterContactOrg: curry((module, component, event) => (
      { requesterContactOrg: module[G.MODEL][G.STATE][G.REF] }
    )),
    supportedBy: curry((module, component, event) => (
      { supportedBy: module[G.MODEL][G.STATE][G.REF] }
    )),
    isNotInactiveAndMyChild: curry((module, component, event) => ({
      status: { max: 79 },
      parent: module[G.MODEL][G.STATE][G.REF],
    })),
    isActiveAndNotMyself: curry((module, component, event) => ({
      status: 50,
      id: `!${module[G.MODEL][G.STATE][G.REF]}`,
    })),
    hasOrganisationAndIsOpen: curry((module, component, event) => ({
      organisation: module[G.MODEL][G.STATE][G.REF],
      status: { max: 79 },
    })),
    hasOrganisationAndIsSolved: curry((module, component, event) => ({
      organisation: module[G.MODEL][G.STATE][G.REF],
      status: { min: 80 },
    })),
  },
  query: {
    orgHasMultipleFilters: hasMultipleFilters(null, [
      'status',
      'country',
      'toBeApproved',
      'toBeValidated',
      'providesSupport',
    ]),
    userOrgsAsParentOrId: fromUserOrgs('parent', 'id'),
    excludeNotConfirmedForRoles,
    ticketHasOrganisationOrPartyOrItem,
    requestHasOrganisationOrPartyOrItem,
  },
}
